import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { createSelector, defaultMemoize } from 'reselect';
import _reduce from 'lodash/reduce';
import _property from 'lodash/property';
import _flatMap from 'lodash/flatMap';
import _flow from 'lodash/flow';
import actionTypes from '../constants/actionTypes';
var getRules = function getRules(fieldIds) {
  return function () {
    for (var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++) {
      rules[_key] = arguments[_key];
    }
    return _reduce(fieldIds, function (fieldsMap, fieldId, index) {
      if (!rules[index]) return fieldsMap;
      return Object.assign(fieldsMap, _defineProperty({}, fieldId, rules[index]));
    }, {});
  };
};
export function createFieldRuleList(fieldIds) {
  return createSelector(fieldIds.map(function (id) {
    return _flow(_property("".concat(id)), _property('renderOptions.validators'));
  }), getRules(fieldIds));
}
function callActionOnSectionChange() {
  return defaultMemoize(function (rules, onAction) {
    onAction({
      type: actionTypes.ON_RULE_CHANGE,
      payload: {
        rules: rules
      }
    });
  });
}
export var getFieldIdsFromSection = function getFieldIdsFromSection(sections) {
  return _flatMap(sections, 'fieldIds');
};
export default function wrapWithValidator(ComposedComponent) {
  return /*#__PURE__*/function (_PureComponent) {
    _inherits(WithValidator, _PureComponent);
    var _super = _createSuper(WithValidator);
    function WithValidator(props) {
      var _this;
      _classCallCheck(this, WithValidator);
      _this = _super.call(this, props);
      _this.callActionOnRuleChange = callActionOnSectionChange();
      var ruleListCreator = createFieldRuleList(getFieldIdsFromSection(props.sections));
      _this.callActionOnRuleChange(ruleListCreator(props.fields), props.onAction);
      _this.state = {
        sections: props.sections,
        ruleListCreator: ruleListCreator
      };
      return _this;
    }
    _createClass(WithValidator, [{
      key: "render",
      value: function render() {
        var props = this.props,
          state = this.state;
        var rules = state.ruleListCreator(props.fields);
        this.callActionOnRuleChange(rules, props.onAction);
        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, props, {
          rules: rules
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, nextState) {
        if (nextState.sections !== nextProps.sections) {
          return {
            sections: nextProps.sections,
            ruleListCreator: createFieldRuleList(getFieldIdsFromSection(nextProps.sections))
          };
        }
        return null;
      }
    }]);
    return WithValidator;
  }(PureComponent);
}